import * as React from "react";

const timeString: React.SFC<{ time: number }> = ({ time }) => {
	let timetostr = '';
	const sec = time % 60;
	const min = Math.round(time / 60) % 60;
	const hour = Math.round(time / 3600) % 24;
	const days = Math.round(time / (3600 * 24));

	timetostr = days + ' d ' + hour + " h " + min + " m " + sec + " s "

	return (<label><small>{timetostr}</small></label>);
}

export default timeString;



// WEBPACK FOOTER //
// ./src/app/products/product-providers/list/timestring.tsx